module.exports = {"id":"165247","name":"Itumeleng Khune","rating":"77","photo":"./data/images/photos/2/165247.png","club":{"name":"Kaizer Chiefs","logo":"./data/images/clubs/KaizerChiefs.png"},"positions":["G"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ItumelengKhune0.json
// module id = 1832
// module chunks = 0